var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"auth-toggle-header"},[_c('router-link',{staticClass:"text-decoration-none",attrs:{"to":{ name: 'signIn' }}},[_vm._v(" Login ")]),_c('router-link',{staticClass:"text-decoration-none",attrs:{"to":{ name: 'signUp' }}},[_vm._v(" Sign Up ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }